import { Component } from "@angular/core";
import { MdDialogRef } from "@angular/material";

@Component({
  selector: "new-portal-alert",
  template: require('./new-portal-alert.component.html'),
  styles: [require('./new-portal-alert.component.scss')]
})
export class NewPortalAlertComponent {
  public constructor(public dialog: MdDialogRef<NewPortalAlertComponent>) {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/new-portal-alert/new-portal-alert.component.ts